
<template>
  <div>
    <div class="lptActionsHeader">
      <el-col :span="12">
        Scenario
      </el-col>
      <el-col class="rawButtonCol" :span="12">
        <el-button @click="toggleRaw()">See raw</el-button>
      </el-col>
    </div>
    <draggable
            v-if="!raw"
            class="dragArea list-group" 
            v-model="scenario"
    >
        <div
            v-bind:class="{'lptActionListItem':true, 'lptActionListItemActive':(element.id === currentlyEdited)}"
            v-for="element in scenario"
            :key="element.id"
            v-on:click="setActive(element.id)"
        >
        <el-row>
          <el-col :span="2">
            <span class="elementId">{{element.id}}.</span>
          </el-col>
          <el-col :span="20">
            <el-row>
              <span>{{getName(element.name)}}</span>
            </el-row>
            <el-row class="stepDescription">{{getStepDetails(element.id)}}</el-row>
          </el-col>
          <el-col :span="2">
            <el-button class="deleteStepButton" v-on:click="deleteStep(element.id)" type="danger" icon="el-icon-delete" size="mini" circle></el-button>
          </el-col>
        </el-row>   
        </div>
    </draggable>
    <div class="rawScenarioJson" v-else>
      <pre v-highlightjs><code class="json">{{rawText}}</code></pre>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BotsService from '../../services/bots.service';
export default {
  name: 'Scenario',
  data () {
    return {
      currentlyEdited: 0,
      raw: false,
      rawText: {}
    }
  },
  components:{
    
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  methods: {
    toggleRaw(){
      this.raw = !this.raw;
      this.rawText = JSON.parse(JSON.stringify(this.$store.state.bot.bot.data.scenario))
    },
    getName(name) {
      return BotsService.getElementName(name);
    },
    getStepDetails(id) {
      return BotsService.getScenarioViewDetails(this.bot, id);
    },
    setActive(id) {
      //set id if step to edit
      this.$store.commit('bot/SET_EDITED_ID', id);
      this.currentlyEdited = id;
    },
    deleteStep(id) {
      var value = 
        this.$store.state.bot.bot.data.scenario.filter(element => element.id != id);
      
      this.rebuildScenario(value);//trigger rebuild to restore sequence of ids
    },
    rebuildScenario(value) {
      var newArray = [];
      //re-set id of each element to it's outer id generated by sortable
      //this way we will have correct order of actions at back-end side
      var that = this;
      value.forEach(function(element, index) {
        //check if currently open element is being edited and change editable id
        if (element.id == that.currentlyEdited) {
          //that.setActive(index + 1);//this way you can edit order of actions and stay have active element opened
        }
        element.id = ++index;
        newArray.push(element);
      });

      this.$store.commit('bot/SORT_SCENARIO', newArray)
    }
  },
  computed: {
    scenario: {
        get() {
          return this.$store.state.bot.bot.data.scenario;
        },
        set(value) {          
          this.rebuildScenario(value);
        }
    },
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>
.rawScenarioJson{
  padding:25px;
  color:grey;
}
.rawButtonCol{
  margin-top:-10px;
  text-align: right;
}
.lptActionListItemActive{
  border-bottom: 3px solid orange;
  font-weight: 800;
  color: orange !important;
}
.elementId{
  color:#999;
}
.deleteStepButton{
  margin-top:30%;
}
.lptActionListItem:nth-child(even){
  background-color: #f5fbf8;
}
.lptActionsHeader {
    background-color: #b5d0c0;
    color:white;
    font-weight: 400;
    font-size: 25px;
    height:50px;
    padding: 15px;
}
.lptActionListItem{
    color: #555;
    padding: 5px 20px;
    cursor:pointer;
}
.lpt-login-wrapper {
  height: 100px;
}

.loginBtn{
  width:100%;
}
.login-group-element {
  margin-bottom: 5px;
}
.stepDescription {
  font-size:0.8em;
}
.login {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    padding: 30px 15px;
    background: #fff;
    width: 400px;
    
    .header {
      text-align: center;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
    }

    .error {
      background-color: red;
      padding: 10px;
      font-size: 12px;
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>
